import { ErrorHandler, Injectable } from '@angular/core'
import { HttpErrorResponse, HttpResponse } from "@angular/common/http"
import { ERRORCODES } from './error-codes'
import { CONSTANTS } from './constants'
import { HelperService } from './services/helper.service'
import { SharedDataService } from './services/shared-data.service'
import { environment } from '../../environments/environment'

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(
    private helper: HelperService,
    private sharedDataService: SharedDataService,
  ) { }

  handleError(error: Error | HttpErrorResponse | HttpResponse<any>) {
    let message: string
    let stack: string

    if (error instanceof HttpResponse) {
      message = error.body
      stack = error.url || ''

      switch (error.body) {
        case ERRORCODES.RESPONSE_FAILED_LOGIN.error_code:
          this.helper.openSnackBar(CONSTANTS.loginError, 0)
          break
        case ERRORCODES.RESPONSE_DATABASE_ERROR.error_code:
          break
        case ERRORCODES.RESPONSE_MALFORMED_PAYLOAD.error_code:
          break
        case ERRORCODES.RESPONSE_RESOURCE_READ_ONLY.error_code:
          break
        case ERRORCODES.RESPONSE_PAYLOAD_SIZE_EXCEEDED.error_code:
          break
        case ERRORCODES.RESPONSE_NOT_EMPTY.error_code:
          break
        case ERRORCODES.RESPONSE_FORBIDDEN.error_code:
          this.helper.openSnackBar(CONSTANTS.forbiddenError, 0)
          break
        default:
          break
      }
    } else if (error instanceof HttpErrorResponse) {
      message = error.message
      stack = error.url || ''
      this.sharedDataService.toggleProgressBarOff()

      if (error instanceof HttpErrorResponse && error.status > 0)
        switch (error.status) {
          case 0:
            this.helper.openSnackBar(CONSTANTS.unknownError, 0)
            break
          case 401:
            // Auf der Login-Seite handhabt die LoginComponent 401-Fehler
            // selbst (Inline-Meldung "Ungültige Logindaten"). Die generische
            // Snackbar "automatisch ausgeloggt" wäre dort irreführend und
            // überdeckt die spezifische Fehlermeldung.
            if (!window.location.pathname.startsWith('/login')) {
              this.helper.openSnackBar(CONSTANTS.unauthenticatedError, 0)
            }
            break
          case 403:
            this.helper.openSnackBar(CONSTANTS.forbiddenError, 0)
            localStorage.removeItem('currentUser')
            sessionStorage.clear()
            window.location.href = '/login'
            break
          case 404:
            this.helper.openSnackBar(CONSTANTS.resourceMissingMessage, 0)
            break
          case 500:
            break
          default:
            break
        }
    } else {
      message = error.message
      stack = error.stack || ''

      if (!environment.production)
        this.helper.openSnackBar(error.message + '/// ' + error.stack, 6000)
    }

    if (!environment.production)
      console.error(message!, stack!)
  }
}
